<template>
  <div>
    <div
      v-if="hasDocuments && disabled && unavailableMessage"
      class="documentation-access-message mb-1"
    >
      {{ unavailableMessage }}
    </div>

    <div
      v-if="hasDocuments"
      class="pdf-grid mb-2"
    >
      <b-button
        v-for="(value, key) in documents"
        :key="key"
        variant="outline-dark"
        :href="documentHref(value)"
        :target="disabled ? null : '_blank'"
        :disabled="disabled"
        :aria-disabled="disabled ? 'true' : 'false'"
        :class="['pdf-button', { 'pdf-button-disabled': disabled }]"
        @click="handleDocumentClick"
      >
        <b-img
          :src="require('@/assets/images/icons/file-icons/adobe_pdf_icon_modern.png')"
          class="pdf-icon pdf-icon-large"
        />
        <div class="pdf-name">
          {{ key }}
        </div>
      </b-button>
    </div>
    <div v-else>
      <b-alert
        show
        variant="warning"
        class="mt-3"
      >
        <div class="alert-body">
          <feather-icon
            icon="AlertTriangleIcon"
            class="mr-50"
          />
          <span>Documentation is not available for this product.</span>
        </div>
      </b-alert>
    </div>
  </div>
</template>

<script>
import {
  BImg, BButton, BAlert,
} from 'bootstrap-vue'

export default {
  components: {
    BImg,
    BButton,
    BAlert,
  },
  props: {
    documents: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    unavailableMessage: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      baseURL: process.env.VUE_APP_BACKEND_PATH,
    }
  },
  computed: {
    hasDocuments() {
      return this.documents && Object.keys(this.documents).length > 0
    },
  },
  methods: {
    documentHref(value) {
      if (this.disabled) {
        return null
      }

      return `${this.baseURL}downloadbrochure.cfm?&${value}`
    },
    handleDocumentClick(event) {
      if (this.disabled) {
        event.preventDefault()
        event.stopPropagation()
        return
      }

      this.$emit('download-document')
    },
  },
}
</script>

<style scoped>
.pdf-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 1.5rem;
  padding: 0.5rem 0;
}

.pdf-button {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 1.5rem 1.5rem;
  min-height: 180px;
  white-space: normal;
}

.documentation-access-message {
  color: #6e6b7b;
  font-size: 0.95rem;
}

.pdf-button-disabled {
  background-color: #f8f8f8 !important;
  border-color: #d8d6de !important;
  color: #82868b !important;
  cursor: not-allowed;
  opacity: 0.65;
}

.pdf-button-disabled .pdf-icon {
  filter: grayscale(1);
  opacity: 0.7;
}

.pdf-button-disabled .pdf-name {
  color: #82868b;
}

.pdf-icon {
  margin-top: 1.5rem;
  margin-bottom: 1rem;
  flex-shrink: 0;
}

.pdf-name {
  text-align: center;
  font-weight: 500;
  font-size: 0.95rem;
  line-height: 1.4;
  word-break: break-word;
}
</style>
